import {Box, SimpleGrid, Icon, Text, VStack, Link} from '@chakra-ui/react';
import {AiOutlineLink, AiOutlineInbox, AiOutlineSend} from 'react-icons/ai'; // Updated Icons
import {Card} from '../../atoms/Card';
import {event} from "../../../../services/analytics";

interface IntroSectionProps {
    title: string;
    description: string;
    icon: React.ElementType;
    guideLink?: string; // Optional guide link
}

const IntroSection = ({title, description, icon, guideLink}: IntroSectionProps) => (
  <VStack spacing={2} align="stretch">
    <Icon as={icon} w={6} h={6}/>
    <Text fontWeight="bold">{title}</Text>
    <Text fontSize="sm">{description}</Text>
    {guideLink && <Link
      fontSize="sm"
      href={guideLink}
      color="blue.500"
      target={"_blank"}
      onClick={() => {
        event({action: "guide_click", params: {guide: guideLink, source: "app"}})
      }}>
          Learn more
    </Link>}
    {/* Conditional rendering of the guide link */}
  </VStack>
);

const UserIntro = () => (
  <Box my={6}>
    <Card>
      <Text fontSize="2xl" fontWeight="medium" mb={6}>How to get started with NotionSender</Text>
      <SimpleGrid columns={{base: 1, md: 3}} spacing={10}>
        <IntroSection
          title="Connect Notion Workspace"
          description="Link your Notion workspace to NotionSender. After linking, you can create and configure a database for your emails."
          icon={AiOutlineLink} // Icon for connecting/linking
        />
        <IntroSection
          title="Save Emails"
          description="Direct your incoming emails to Notion. Use unique email addresses for automatic capture in your database."
          icon={AiOutlineInbox} // Icon for email/inbox
          guideLink="/blog/saving-emails-to-notion" // Link to the saving email guide
        />
        <IntroSection
          title="Send Emails"
          description="Utilize NotionSender for sending emails directly from your workspace. Use Notion pages as emails."
          icon={AiOutlineSend} // Icon for sending emails
          guideLink="/blog/sending-emails-from-notion" // Link to the sending email guide
        />
      </SimpleGrid>
    </Card>
  </Box>
);

export default UserIntro;
